import api from "../../../../app/ApiConfig";
import { Apis } from "../../../../config";
import { NotificationManager } from "react-notifications";

const getOrderCreateByUser = async (data) => {
  try {
    let result = await api.post(Apis.GetOrderCreateByUser, data);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const capturePayment = async (data) => {
  try {
    let result = await api.post(Apis.GetPaymentCapture, data);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
const sendOrderEmail = async (data) => {
  try {
    let result = await api.post(Apis.GetOrderEmail, data);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const RazorpayOrder = async ({ cartItems }) => {
  try {
    const data = { cartItems };

    const result = await api.post(Apis.GetRazorpayOrder, data);


    if (result.data && result.data.success === false) {
      return { error: result.data };
    }

    if (!result.data || !result.data.orderId) {
      return { error: { message: "Order ID missing in response", data: result.data } };
    }

    return { orderId: result.data.orderId, data: result.data };
  } catch (error) {
    console.error("Error creating Razorpay order:", error);
    return { error: { message: error.message } };
  }
};




const createPreorder = async (data) => {
  try {
    let result = await api.post(Apis.GetPreOrderCreate, data);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getOrderByUser = async (id) => {
  try {
    let result = await api.get(`${Apis.GetOrderByUser}?id=${id}`);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};


const getOrderRefreshByUser = async (id) => {
  try {
    let result = await api.post(`${Apis.GetOrderRefresh}?custId=${id}`);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getOrderDownload = async (filename) => {
  try {
    let result = await api.get(
      `${Apis.GetOrderDownload}?filename=${filename}`,
      {
        responseType: "blob", // Ensure the response is a binary blob
      }
    );

    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export default {
  getOrderCreateByUser,
  getOrderRefreshByUser,
  capturePayment,
  getOrderByUser,
  getOrderDownload,
  createPreorder,
  RazorpayOrder,
  sendOrderEmail,
};
